import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import lt from './lt.json';
import en from './en.json';
import pl from './pl.json';
import ru from './ru.json';
import ja from './ja.json';
import es from './es.json';
import fr from './fr.json';
import et from './et.json';
import lv from './lv.json';
import de from './de.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      lt: { translation: lt },
      en: { translation: en },
      pl: { translation: pl },
      ru: { translation: ru },
      ja: { translation: ja },
      es: { translation: es },
      fr: { translation: fr },
      et: { translation: et },
      lv: { translation: lv },
      de: { translation: de },
    },
    lng: localStorage.getItem('fantastai_lang') || 'lt',
    fallbackLng: 'lt',
    interpolation: { escapeValue: false },
  });

export default i18n;
